import i18n from "@/i18n";

export default [{ id: "order_approval", name: i18n.t("integrations.temporary_replacement.type.order_approval") }];
